module.exports = __webpack_public_path__ + "media/ecu/favicon-c44f4b92.ico";